import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Bonus } from './components/Bonus';
import { TargetAudience } from './components/TargetAudience';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Agitation data-id="element-5" />
        <Solution data-id="element-6" />
        <Modules data-id="element-7" />
        <Bonus data-id="element-8" />
        <TargetAudience data-id="element-9" />
        <Pricing data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
    </div>;
}